import { v1 as uuidv1 } from 'uuid';

export const TYPE_SHOW = `Confirmation: SHOW→${uuidv1()}`;
export const TYPE_CLOSE = `Confirmation: CLOSE→${uuidv1()}`;
